import React from 'react'
import InfoBlock from '../../shared/infoBlock'
import Title from '../../shared/title'
import AngleBracketButton from '../../shared/angleBracketButton'
import lottie from 'lottie-web'
import animationData from '../../../static/animations/worldwide-animation.json'
import { isNarrowDesktop } from '../../../media-queries'

export default class Universities extends React.Component {
  state = {
    height: getHeight(),
  }

  componentDidMount() {
    if (window) {
      window.addEventListener('resize', this.updateHeight)
    }

    lottie.loadAnimation({
      container: this.getAnimationElement(), // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData,
    })
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.updateHeight)
    }
  }

  setHeight = () => {
    this.setState({ height: getHeight() })
  }

  updateHeight = () => {
    if (!isNarrowDesktop()) {
      this.setHeight()
    }
  }

  getAnimationElement = () => {
    if (document) {
      return document.getElementById('animation')
    }
  }

  render() {
    const [greenTitle] = this.props.title.split(' ')
    const blackTitle = this.props.title.substr(greenTitle.length)
    return (
      <div style={{ display: 'flex' }}>
        <div
          style={{
            height: this.state.height,
            minHeight: 600,
            padding: '5rem 10vw 0 5rem',
            width: '50vw',
            display: 'flex',
            flexDirection: 'column',
            ...this.props.style,
          }}
        >
          <div style={{ margin: 'auto' }}>
            <div style={{ marginTop: '-7rem' }}>
              <InfoBlock
                title={greenTitle}
                bigTitle={true}
                accentColor={'black'}
                extra={blackTitle}
                text={this.props.text}
                style={{ marginBottom: '5rem', color: '#8CBD8C' }}
              />
              <div
                style={{
                  margin: '0 auto',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <AngleBracketButton
                  text={'Our programme'}
                  hasCaret={false}
                  link={'/programme'}
                  style={{
                    background: '#8CBD8C',
                    minWidth: '204px',
                    marginLeft: '-2rem',
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          id={'animation'}
          style={{
            width: '50vw',
            marginLeft: '-2rem',
          }}
        />
      </div>
    )
  }
}

const getHeight = () => {
  if (window) {
    if (isNarrowDesktop()) return 750
    else return window.innerHeight - 45
  }
}



// WEBPACK FOOTER //
// ./src/components/homepage/universities/index.js